<textarea pInputTextarea spellcheck=false class="width100p height100p monospace no-resize" [ngModel]="stackTrace"></textarea>        